import moment from "moment";

export const ESTADO_PAGO_NO_PROVEEDOR = {
  PENDIENTE: "pendiente",
  PAGADO: "pagado",
  ANULADO: "anulado",
};

export const ESTADOS_OPTIONS = [
  { value: ESTADO_PAGO_NO_PROVEEDOR.PENDIENTE, label: "Pendiente" },
  { value: ESTADO_PAGO_NO_PROVEEDOR.PAGADO, label: "Pagado" },
  { value: ESTADO_PAGO_NO_PROVEEDOR.ANULADO, label: "Anulado" },
];

export const esPendiente = (row) =>
  String(row?.estado || "").toLowerCase() === ESTADO_PAGO_NO_PROVEEDOR.PENDIENTE;

export const etiquetaEstado = (estado) => {
  const found = ESTADOS_OPTIONS.find((o) => o.value === estado);
  return found?.label ?? estado ?? "—";
};

export const colorEstado = (estado) => {
  switch (String(estado || "").toLowerCase()) {
    case ESTADO_PAGO_NO_PROVEEDOR.PENDIENTE:
      return "warning";
    case ESTADO_PAGO_NO_PROVEEDOR.PAGADO:
      return "success";
    case ESTADO_PAGO_NO_PROVEEDOR.ANULADO:
      return "default";
    default:
      return "default";
  }
};

export const idDeEmpresa = (emp) =>
  emp?.idempresa ?? emp?.id_empresa ?? emp?.id ?? null;

export const nombreDeEmpresa = (emp) =>
  emp?.empresa ??
  emp?.nombre ??
  emp?.nombre_empresa ??
  `Empresa ${idDeEmpresa(emp)}`;

export const hoyIso = () => moment().format("YYYY-MM-DD");

export const formatearFecha = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("DD/MM/YYYY") : "—";
};

export const formatMoneda = (value) => {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
  });
};

export const MOTIVO_MAX_LENGTH = 250;

export const usuarioActual = () =>
  String(localStorage.getItem("user") || "").trim();

export const itemsListado = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.pagos)) return data.pagos;
  return [];
};
